import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useGetUserSystemPermissions } from '../../queries/user-query';
import { Button, ButtonVariantProps } from '../../components/atoms/Button';
import { InlineGroup, HorizontalAlignProps } from '../../components/atoms/InlineGroup';
import { PageContainer } from '../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { ServiceTypeList } from './ServiceTypeList/ServiceTypeList';
import { isUserHasPermission } from '../../configs/permissions';
import { ActionPermissions, CustomPermission, } from '../../@types';
import { Wrapper } from '../../styled/common.styles';
import { Link } from '../../components/atoms/Link';
import { ServiceType } from './AddEditServiceType/AddEditServiceType.props';
import { RoutePath } from '../../@types/route.type';
import { PLATFORM_NAME } from '../../configs/common';
import { TabHandler } from '../../handlers/TabHandler';

export const ServiceTypes: React.FC = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`List Services Types | ${PLATFORM_NAME}`);
  
  return (
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            {ServiceType.ListServiseTypes}
          </Typography>
          {isUserHasPermission(ActionPermissions.Configure_Service_Types_Create, permissions) && (
            <Link href={RoutePath.AddServiceType}>
              <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />}>
                {ServiceType.AddServiceType}
              </Button>
            </Link>
          )}
        </InlineGroup>
        {isUserHasPermission(ActionPermissions.Configure_Service_Types_Search_View, permissions) && (
          <ServiceTypeList/>
        )}
      </Wrapper>
    </PageContainer>
  );
};